<template>
  <drop @dragover="handleDragover(...arguments)" @drop="handleDrop">
    <v-tabs style="height: 100%; display: flex; flex-direction: column" v-model="selectedTab" align-with-title>
      <mission-detail-nav-tab
        class="missiondetailtab"
        v-for="tab in tabItems"
        :key="`${tab.cmp}-${tab.id}-${isleft}`"
        :tab="tab"
        :isleft="isleft"
      />
      <v-tab
        style="flex: 0 0 auto"
        href="MissionMenu-0"
        class="missiondetailmore"
        @click.stop.prevent="$store.myActions.MISSION_NAVTO_DETAIL({ cmp: 'MissionMenu', isleft, id: 0 })"
        :title="$t('Pilot.MissionInfos.AddDetailTabTooltip')"
      >
        <v-icon>mdi-plus</v-icon>
      </v-tab>

      <v-tabs-items style="flex: 1 1 auto; display: flex" v-model="selectedTab">
        <v-tab-item
          :reverse-transition="false"
          :transition="false"
          :value="`${tab.cmp}-${tab.id}`"
          v-for="tab in tabItems"
          :key="`${tab.cmp}-${tab.id}-${isleft}`"
        >
          <component
            :is="tab.cmp"
            :isleft="isleft"
            :uiid="`${tab.cmp}-${tab.id}`"
            :tryClose="tab.tryClose"
            :isVisible="`${tab.cmp}-${tab.id}` == selectedTab"
            :mission="currentDetailMission.mission"
          />
        </v-tab-item>
        <v-tab-item :reverse-transition="false" :transition="false" value="MissionMenu-0">
          <mission-menu :isleft="isleft" />
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>
  </drop>
</template>
<script>
import MissionDetailAd2cp from '@/components/mission/MissionDetailAd2cp'
import MissionDetailAnticollision from '@/components/mission/MissionDetailAnticollision'
import MissionDetailEncryption from '@/components/mission/MissionDetailEncryption'
import MissionDetailQuickControl from '@/components/mission/MissionDetailQuickControl'
import MissionDetailConsole from '@/components/mission/MissionDetailConsole'
import MissionDetailCoriolis from '@/components/mission/MissionDetailCoriolis'
import MissionDetailFileTransfer from '@/components/mission/MissionDetailFileTransfer'
import MissionDetailFileUpload from '@/components/mission/MissionDetailFileUpload'
import MissionDetailFleetManagement from '@/components/mission/MissionDetailFleetManagement'
import MissionDetailFtpRsync from '@/components/mission/MissionDetailFtpRsync'
import MissionDetailImage from '@/components/mission/MissionDetailImage'
import MissionDetailInformation from '@/components/mission/MissionDetailInformation'
import MissionDetailLogBook from '@/components/mission/MissionDetailLogBook'
import MissionDetailMap from '@/components/mission/MissionDetailMap'
import MissionDetailMapLayer from '@/components/mission/MissionDetailMapLayer'
import MissionDetailMissionPlan from '@/components/mission/MissionDetailMissionPlan'
import MissionDetailNavigationGraphics from '@/components/mission/MissionDetailNavigationGraphics'
import MissionDetailNavigationGraphicsList from '@/components/mission/MissionDetailNavigationGraphicsList'
import MissionDetailNavTab from '@/components/mission/MissionDetailNavTab'
import MissionDetailNextSurfacingDo from '@/components/mission/MissionDetailNextSurfacingDo'
import MissionDetailNmeaGraphics from '@/components/mission/MissionDetailNmeaGraphics'
import MissionDetailNmeaGraphicsList from '@/components/mission/MissionDetailNmeaGraphicsList'
import MissionDetailScienceGraphics from '@/components/mission/MissionDetailScienceGraphics'
import MissionDetailScienceGraphicsList from '@/components/mission/MissionDetailScienceGraphicsList'
import MissionDetailSendMail from '@/components/mission/MissionDetailSendMail'
import MissionDetailSingleWayPoint from '@/components/mission/MissionDetailSingleWayPoint'
import MissionEndSimulationSinglePlots from '@/components/mission/MissionEndSimulationSinglePlots'
import MissionEndSimulationSinglePlotsList from '@/components/mission/MissionEndSimulationSinglePlotsList'
import MissionMenu from '@/components/mission/MissionMenu'
import { mapGetters } from 'vuex'

//import CacheAllGraphicsList from  '@/components/cache/CacheAllGraphicsList'

export default {
  name: 'MissionDetail',
  components: {
    MissionDetailNavTab,
    MissionMenu,
    MissionDetailConsole,
    MissionDetailFleetManagement,
    MissionDetailInformation,
    MissionDetailLogBook,
    MissionDetailMap,
    MissionDetailMissionPlan,
    MissionDetailNavigationGraphics,
    MissionDetailNavigationGraphicsList,
    MissionDetailAd2cp,
    MissionDetailImage,
    MissionDetailScienceGraphics,
    MissionDetailScienceGraphicsList,
    MissionDetailFileTransfer,
    MissionDetailFileUpload,
    MissionDetailNextSurfacingDo,
    MissionDetailSendMail,
    MissionDetailMapLayer,
    MissionDetailSingleWayPoint,
    MissionDetailFtpRsync,
    MissionDetailNmeaGraphicsList,
    MissionDetailNmeaGraphics,
    MissionDetailCoriolis,
    MissionDetailAnticollision,
    MissionDetailEncryption,
    MissionDetailQuickControl,
    MissionEndSimulationSinglePlots,
    MissionEndSimulationSinglePlotsList /*,CacheAllGraphicsList*/,
  },
  props: {
    isleft: Boolean,
  },
  data() {
    return {
      selectedTab: null,
      editedTabs: {},
    }
  },
  mounted() {
    this.selectedTab = this.selectedUiid
  },
  computed: {
    ...mapGetters(['currentDetailMission']),
    tabs() {
      return this.isleft ? this.currentDetailMission.tabsleft : this.currentDetailMission.tabsright
    },
    tabItems() {
      return this.tabs.tabs
    },
    selectedUiid() {
      return this.tabs.selected
    },
  },
  watch: {
    selectedUiid(newValue) {
      this.$nextTick(() => {
        this.selectedTab = newValue
        this.$store.myActions.UI_REFRESH_COMPONENT(newValue)
      })
    },
  },
  methods: {
    handleDragover(data, event) {
      if (data && (!data.cmp || this.isleft == data.isleft)) {
        event.dataTransfer.dropEffect = 'none'
      }
    },
    handleDrop(data) {
      if (data) {
        this.$store.myActions.MISSION_MOVE_TAB(data)
      }
    },
  },
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.v-tabs {
  border-bottom: 1px solid #efefef;
}
.missiondetailtab,
.missiondetailmore {
  border-right: 1px solid #efefef;
}
.missiondetailtab .v-tabs__item {
  padding-right: 0;
}
.v-tabs__content {
  display: flex;
}
</style>
